export default __webpack_public_path__ + "static/media/Modelo 6.4bf72416.png";